import { createActions, createReducer } from 'reduxsauce'

import DespesasPorEmpenhoService from '../../servicos/DespesasPorEmpenhoService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaDespesasPorEmpenhoInicio: [],
    buscaDespesasPorEmpenhoSucesso: ['despesasPorEmpenho'],
    buscaDespesasPorEmpenhoErro: ['erro'],
    setDespesasPorEmpenhoEstadoDT: ['estado'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
    selecionado: null,
    dataAtualizacaoDados: null,
    estadoDT: {},
}

// Ação para busca completa
Creators.buscaDespesasPorEmpenho = filtro => {
    return dispatch => {
        dispatch(Creators.buscaDespesasPorEmpenhoInicio())
        let serv = new DespesasPorEmpenhoService()
        return serv
            .consultar(filtro)
            .then(response => dispatch(Creators.buscaDespesasPorEmpenhoSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaDespesasPorEmpenhoErro(error)))
    }
}

const buscaDespesasPorEmpenhoInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaDespesasPorEmpenhoErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaDespesasPorEmpenhoSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.despesasPorEmpenho.resultado, dataAtualizacaoDados: action.despesasPorEmpenho.dataAtualizacaoDados, carregando: false }
}

const setDespesasPorEmpenhoEstadoDT = (state = INITIAL_STATE, action) => {
    return { ...state, estadoDT: action.estado }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_DESPESAS_POR_EMPENHO_INICIO]: buscaDespesasPorEmpenhoInicio,
    [Types.BUSCA_DESPESAS_POR_EMPENHO_ERRO]: buscaDespesasPorEmpenhoErro,
    [Types.BUSCA_DESPESAS_POR_EMPENHO_SUCESSO]: buscaDespesasPorEmpenhoSucesso,
    [Types.SET_DESPESAS_POR_EMPENHO_ESTADO_DT]: setDespesasPorEmpenhoEstadoDT,
})
